<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-share-report :report-id="reportId">
			<template #return>
				<base-button
					@click.native="syncModal = false"
					type="white"
					size="md"
					class="px-0 bg-transparent font-weight-normal shadow-none"
					>Cancel</base-button
				>
			</template>
		</form-share-report>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormShareReport from "@components/FormShareReport";

export default {
	name: "modal-share-report",
	components: {
		FormShareReport,
	},
	props: {
		reportId: {
			required: true,
		},
	},
	data() {
		return {
			syncModal: false,
			formProcessing: false,
		};
	},
	mounted() {
		this.$emitter.on("toggle-modal", (payload) => {
			if ("share-report" === payload.key) this.syncModal = payload.active;
		});

		this.$emitter.on("share-report-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
